import { createFileRoute, redirect } from '@tanstack/react-router';

export function getAdminAgentRedirectHref(location: {
    pathname: string;
    searchStr: string;
    hash: string;
}): string {
    // `/admin/agent/automations` already holds the older automation pages.
    const path = location.pathname
        .replace(
            /^\/admin\/v3-agent\/automations(?=$|\/)/,
            '/admin/agent/v3-automations',
        )
        .replace(
            /^\/admin\/v3-agent\/connections(?=$|\/)/,
            '/admin/agent/connections',
        )
        .replace(/^\/admin\/v3-agent(?=$|\/)/, '/admin/agent');
    return `${path}${location.searchStr}${location.hash}`;
}

export const Route = createFileRoute('/_app/admin/v3-agent')({
    beforeLoad: ({ location }) => {
        throw redirect({
            href: getAdminAgentRedirectHref(location),
            replace: true,
        });
    },
});
